import React from "react";
import "../styles/AboutUsInformations.css";
import FreshIngredientsIcon from "../assets/icons/carrot.svg";
import FamilyIcon from "../assets/icons/family.svg";
import ClientIcon from "../assets/icons/client.svg";
import MenuIcon from "../assets/icons/menu.svg";

function AboutUsInformations() {

    const features = [
        {
            title: 'Świeże składniki',
            description: 'W naszej kuchni stawiamy na najwyższą jakość produktów – używamy wyłącznie świeżych składników, aby każde danie zachwycało smakiem i aromatem.',
            icon: FreshIngredientsIcon
        },
        {
            title: 'Rodzinna atmosfera',
            description: 'Restauracja Sami Swoi to miejsce, gdzie każdy czuje się jak w domu. Nasz przyjazny personel i przytulne wnętrze tworzą idealną przestrzeń na spotkania z bliskimi.',
            icon: FamilyIcon
        },
        {
            title: 'Wyjątkowe menu',
            description: 'Nasze menu to starannie wyselekcjonowane dania, które zadowolą nawet najbardziej wymagające podniebienia. Każdy posiłek przygotowujemy z pasją i dbałością o szczegóły.',
            icon: MenuIcon
        },
        {
            title: 'Wyjątkowa dbałość o klienta',
            description: 'Twoje zadowolenie jest dla nas najważniejsze. Dlatego nasz personel zawsze stara się spełniać oczekiwania gości, zapewniając komfortową i przyjemną wizytę w naszej restauracji.',
            icon: ClientIcon
        }
    ]

    return (
        <div className="container-fluid about-us-informations-section-background my-5-5 py-5">
            <div className="container">
                <div className="row">
                    <div className="col-12 col-lg-7">
                        <div className="row">
                            {features.map((features, index) => {
                                return (
                                <div key={index} className="col-12 col-md-6 mb-4">
                                    <div className="feature-card">
                                        <img src={features.icon} className="icon icon-large icon-invert mb-3" />
                                        <h6>{features.title}</h6>
                                        <p>{features.description}</p>
                                    </div>
                                </div>
                            )})}
                        </div>
                    </div>
                    <div className="col-12 col-lg-5 d-flex align-items-center about-us-informations-photo-container">
                        <img src={require('../assets/photos/restaurant.webp')} className="about-us-informations-photo rounded img-shadow" />
                    </div>
                </div>
            </div>
        </div>
    )

}

export default AboutUsInformations;